// ****************************** Import From AWS Amplify ******************************** //

import '/src/amplify-config';

// ****************** CSS ******************** //

import "./contact.css";

// **************** Images ****************** //

import "/src/assets/images/fp-box-3028.jpg";

// ************ Social Icons ***************** //

import "/src/assets/social-icons/instagram-colorful.svg";

// ************ Add Top Nav & Footer ***************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// ****************************** Import Modals ******************************** //

//*** User Error Modal *** //
import '/src/popups/user-popup.js';
import '/src/popups/user-popup.css';

// ************ Add Email Signup Form *************** //

import '/src/nav-header-footer/email-signup-form.js';

// ********************** User Popup Modal *********************** //

var userPopup = document.getElementById('user-popup');
var popupClose = document.getElementById('popup-close');

popupClose.onclick = function() {
  	userPopup.style.display = "none";
}

// ****************************** JS - Contact Form ******************************** //

const scriptURL = 'https://script.google.com/macros/s/AKfycbyhWv8PmLHWgBxFIApkOnjZAwV7HxMsDNVX2CsPK3sJtZUuvN6aNh2UmDpp9Yul6jVrAQ/exec';
			
const contactSubmitBtn = document.getElementById("contact-submit-button");
			
const form = document.forms["contact-to-google-sheet"];

			
contactSubmitBtn.addEventListener('click', e => {
				
	e.preventDefault()

		let firstName = document.forms["contact-to-google-sheet"]["firstName"].value.trim();
  	let lastName = document.forms["contact-to-google-sheet"]["lastName"].value.trim();
  	let email = document.forms["contact-to-google-sheet"]["email"].value.trim();
  	let phone = document.forms["contact-to-google-sheet"]["phone"].value.trim();
  	let message = document.forms["contact-to-google-sheet"]["message"].value.trim();
				
	// console.log(firstName);
	// console.log(lastName);
	// console.log(email);
	// console.log(phone);
	// console.log(message);

	const formData = new FormData(form);

	const userPopup = document.getElementById('user-popup');

	if (firstName == "") {
      	$("#popup-title").html('Oops! Missing Info');
      	$("#popup-main-text").html('Please enter your first name.');
      	userPopup.style.display = "block";
    	return false;

    } else if (lastName == "") {
      	$("#popup-title").html('Oops! Missing Info');
      	$("#popup-main-text").html('Please enter your last name.');
      	userPopup.style.display = "block";
    	return false;
    
    } else if (email == "") {
      	$("#popup-title").html('Oops! Missing Info');
      	$("#popup-main-text").html('Please enter your email address.');
      	userPopup.style.display = "block";
    	return false;

    } else if (message == "") {
      $("#popup-title").html('Oops! Missing Info');
      $("#popup-main-text").html('Please enter a message.');
      userPopup.style.display = "block";
    	return false;

    } else {
		submitContactForm(formData);  
	}
});


function submitContactForm(formData) {

	// console.log("About to submit");

	contactSubmitBtn.disabled = true;
    contactSubmitBtn.value = "Submitting...";

  	fetch(scriptURL, { method: "POST", body: formData })
  		
  		.then((response) => response.json())
  	
  			.then ((result) =>  { 

			    console.log('Submission Result:', result.result);

			    console.log('data:', result.data);

    			var errorMessage = "";

    if (result.result == 'success') {
    	
    		contactSubmitBtn.disabled = false;
      	contactSubmitBtn.value = "Thank you!";
	  
	  		$("#popup-title").html('Thank You!');
      	$("#popup-main-text").html("We will reply to your message soon.");
      	userPopup.style.display = "block";

      	sendEmailJS();
       
       	form.reset(); 

    		contactSubmitBtn.value = "Submit";
    }

    if (result.result == 'error') {

    	// console.log('Submission Result:', result.result.e);

    	$("#popup-title").html('Oops!');
      	$("#popup-main-text").html('Something went wrong.');
      	$("#popup-sub-text").html('Please try again.');
      	userPopup.style.display = "block";

      	form.reset();
      	
      	contactSubmitBtn.disabled = false;
      	contactSubmitBtn.value = "Submit";
    }
  })
    .catch(error => { 

        $("#popup-title").html('Oops!');
      	$("#popup-main-text").html('Something went wrong.');
      	$("#popup-sub-text").html('Please try again.');
      	userPopup.style.display = "block";
            
    	form.reset(); 

    	contactSubmitBtn.disabled = false;
      	contactSubmitBtn.value = "Submit";
  });
}

	 function handleMediaQueryChange(e) {
      if (e.matches) {
        userPopup.setAttribute('style', 'top: 40%; right: 33%;');
      } else {
        userPopup.setAttribute('style', 'top: 40%; right: 0%;');
      }
    }

const mediaQuery = window.matchMedia('(min-width: 1025px)');
mediaQuery.addEventListener('change', handleMediaQueryChange);
handleMediaQueryChange(mediaQuery);

// ****************************** JS - EmailJS for Contact Form ******************************** //


function sendEmailJS() {

	const templateParams = {
		firstName: document.getElementById("firstName").value.trim(),
  	lastName: document.forms["contact-to-google-sheet"]["lastName"].value.trim(),
  	email: document.forms["contact-to-google-sheet"]["email"].value.trim(),
  	phone: document.forms["contact-to-google-sheet"]["phone"].value.trim(),
  	message: document.forms["contact-to-google-sheet"]["message"].value.trim(),
	};

	console.log("templateParams: ", templateParams);

	emailjs
		.send("service_dxz4hwm", "template_qujaclf", templateParams)
			.then(() => {
				console.log("Message sent successfully.");
			})
		.catch((error) => {
			console.log("Error sendig email: ", error);
		});
}












